
import styles from './AnalyticsScreen.module.css';
import helpers from './helpers.js';

import ScreenHeader from "./components/ScreenHeader.js";


function AnalyticsScreen(props) {
  // console.log(helpers.clx(styles.MainBlack, "green"));
  return (
    <div className={helpers.clx("mainWhiteContainerContent", props.screenTransitioning ? "mainWhiteContainerContentHidden" : "")}>
          <ScreenHeader iconName="FaChartLine" name={"Analytics"} content={"Have a look at how you're doing with all your biochar related data. For optimal results, make sure to fill in the MRV section."}/>
          Analytics CONTENT
        </div>
  );
}

export default AnalyticsScreen;
